import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectOccupationOptions } from 'state/constants'
import { RequirementCardContainer } from 'components/Shared/Fields/styles'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'
import FieldTitleAndSubTitle from 'components/Shared/Fields/FieldTitleAndSubTitle'

import Field from 'components/Shared/Fields'

enum OCCUPATION_TYPE {
    STUDENT = 1,
    PART_TIME_EMPLOYED = 2,
    FULL_TIME_EMPLOYED = 3,
    HOUSE_WIFE_HUSBAND = 4,
    UNEMPLOYED = 5,
    SELF_EMPLOYED_FREELANCE = 6,
    RETIRED = 7,
}

const OccupationRequirement: React.FC<{
    name: string
    onRemove: () => void
    requirementUuid?: string
    isReadOnly?: boolean
}> = ({ name, onRemove, requirementUuid, isReadOnly }) => {
    const [t] = useTranslation()
    const occupationOptions = useSelector(selectOccupationOptions)
    const labelList: { [key: number]: string } = {
        [OCCUPATION_TYPE.STUDENT]: t('employmentStatus.student'),
        [OCCUPATION_TYPE.PART_TIME_EMPLOYED]: t('employmentStatus.partTimeEmployed'),
        [OCCUPATION_TYPE.FULL_TIME_EMPLOYED]: t('employmentStatus.fullTimeEmployed'),
        [OCCUPATION_TYPE.HOUSE_WIFE_HUSBAND]: t('employmentStatus.housewifeHousehusband'),
        [OCCUPATION_TYPE.UNEMPLOYED]: t('employmentStatus.unemployed'),
        [OCCUPATION_TYPE.SELF_EMPLOYED_FREELANCE]: t('employmentStatus.selfEmployed'),
        [OCCUPATION_TYPE.RETIRED]: 'retired',
    }
    const options = useMemo(() => {
        return occupationOptions.map(option => ({
            value: option.id,
            label: labelList[option.id],
        }))
    }, [occupationOptions, t])

    return (
        <RequirementCardContainer isCard>
            <FieldTitleAndSubTitle
                title={t('campaignEditor.requirement.employmentStatusHeader')}
                subtitle={t('campaignEditor.requirement.employmentStatusSubtext')}
                isRequired
                isReadOnly={isReadOnly}
                onClose={onRemove}
            />
            <CampaignEditorInputFieldContainer>
                <Field.CheckBoxMultiGroupField
                    title={t('campaignRequirement.occupationHeader')}
                    name={name}
                    options={options}
                    width="100%"
                    identifier={`${requirementUuid}_${fieldIdentifiers.occupation}`}
                />
            </CampaignEditorInputFieldContainer>
        </RequirementCardContainer>
    )
}

export default OccupationRequirement
